// import React from 'react';
// import '../Maintenance-styles/modalSelector.css'



// const SelectorUserModal = ({ users = [], onClose, onSelectUser }) => {
//     return (
//       <div className="modal">
//         <button className="close-modal-button" onClick={onClose}>
//           &times;
//         </button>
//         <h2>Seleccionar Usuarios</h2>
//         <div className="modal-select-list">
//           {users.map((user) => (
//             <div
//               key={user.user_id}
//               className="select-item"
//               onClick={() => {
//                 onSelectUser(user);
//                 onClose();
//               }}
//             >
//               {user.name} - {user.mail}
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   };
  
//   export default SelectorUserModal;
  




import React, { useState } from 'react';
import '../Maintenance-styles/modalSelector.css';

const SelectorUserModal = ({ users = [], onClose, onSelectUser }) => {
  // Estado para almacenar el término de búsqueda
  const [searchTerm, setSearchTerm] = useState('');

  // Filtrar los usuarios según el término de búsqueda
  const filteredUsers = users.filter((user) =>
    `${user.name} ${user.mail}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="modal">
      <button className="close-modal-button" onClick={onClose}>
        &times;
      </button>
      <h2>Seleccionar Usuarios</h2>

      <input
        type="text"
        className="input search-user"
        placeholder="Buscar usuario..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)} // Actualizar el término de búsqueda
      />

      <div className="modal-select-list">
        {filteredUsers.map((user) => (
          <div
            key={user.user_id} // Aseguramos que cada usuario tenga una key única
            className="select-item"
            onClick={() => {
              onSelectUser(user);
              onClose();
            }}
          >
            {user.name} - {user.mail}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectorUserModal;
